import { render } from "./MondrianSchemasWorkflowTab.vue?vue&type=template&id=7a0a68af&scoped=true&ts=true"
import script from "./MondrianSchemasWorkflowTab.vue?vue&type=script&lang=ts"
export * from "./MondrianSchemasWorkflowTab.vue?vue&type=script&lang=ts"

import "./MondrianSchemasWorkflowTab.vue?vue&type=style&index=0&id=7a0a68af&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0a68af"]])

export default __exports__